/* IT HIPPIE — verrouillage du fond quand le panier est ouvert sur mobile.
   1) On fige le <body> (position:fixed) : marche bien sur Safari iOS.
   2) On bloque aussi les gestes tactiles (touchmove) partout SAUF dans la liste
      d'articles (.cart-drawer__main) : indispensable pour Chrome iOS, où figer le
      body ne suffit pas toujours.
   La liste d'articles reste scrollable ; les taps (fermer, champs, boutons) ne sont
   pas bloqués (touchmove != tap). Limité au mobile (<=749px).

   17 oct. :
   - les pop-ups ouverts par-dessus le panier (ajout rapide, M'avertir, guide des tailles)
     restent scrollables : avant, ils étaient bloqués et on n'atteignait pas toujours
     les tailles ou le bouton « Ajouter » sur petit écran ;
   - clavier ouvert sur le champ email du panier : le panier se cale sur la zone visible
     au-dessus du clavier (Instagram / Facebook / Safari iOS), pour que le champ et le
     bouton restent visibles ;
   - champs de saisie en 16 px sur mobile : en dessous, iOS zoome la page au toucher. */
(function () {
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;

  var ALLOW_SCROLL = '.cart-drawer__main, .ithqa, .ith-bis, .ithqa-guide, .tcm';

  var scrollY = 0;
  var locked = false;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  /* ---------- Styles mobile (zoom iOS + panier au-dessus du clavier) ---------- */
  (function injectCss() {
    if (document.getElementById('ith-mobile-fix-style')) return;
    var s = document.createElement('style');
    s.id = 'ith-mobile-fix-style';
    s.textContent =
      '@media screen and (max-width:749px){' +
        'cart-drawer input[type=email],cart-drawer input[type=text],cart-drawer input[type=tel],' +
        '.cart-promo-newsletter__input,.ith-bis__email{font-size:16px !important}' +
        'html.ith-kb-open cart-drawer .cart-drawer__inner,' +
        'html.ith-kb-open cart-drawer.is-visible .cart-drawer__inner{' +
          'top:var(--ith-vv-top,0px) !important;bottom:auto !important;' +
          'height:var(--ith-vv-h,100dvh) !important;max-height:var(--ith-vv-h,100dvh) !important}' +
      '}';
    (document.head || document.body).appendChild(s);
  })();

  // Laisse scroller la liste d'articles et les pop-ups ; bloque le scroll partout ailleurs.
  function onTouchMove(e) {
    var t = e.target;
    if (t && t.closest && t.closest(ALLOW_SCROLL)) return;
    e.preventDefault();
  }

  function lock() {
    if (locked || !isMobile()) return;
    locked = true;
    scrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.addEventListener('touchmove', onTouchMove, { passive: false });
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    document.removeEventListener('touchmove', onTouchMove, { passive: false });
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    window.scrollTo(0, scrollY);
  }

  new MutationObserver(function () {
    if (cd.classList.contains('is-visible')) lock();
    else { unlock(); kbOff(); }
  }).observe(cd, { attributes: true, attributeFilter: ['class'] });

  /* ---------- Clavier ouvert sur un champ du panier ---------- */
  var vv = window.visualViewport;
  var kbActive = false;

  function syncViewport() {
    if (!kbActive || !vv) return;
    var root = document.documentElement;
    root.style.setProperty('--ith-vv-h', Math.round(vv.height) + 'px');
    root.style.setProperty('--ith-vv-top', Math.round(vv.offsetTop) + 'px');
  }

  function kbOn(input) {
    if (!vv || !isMobile()) return;
    kbActive = true;
    document.documentElement.classList.add('ith-kb-open');
    syncViewport();
    // le temps que le clavier finisse de monter
    setTimeout(function () {
      syncViewport();
      try { input.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }, 300);
  }

  function kbOff() {
    if (!kbActive) return;
    kbActive = false;
    var root = document.documentElement;
    root.classList.remove('ith-kb-open');
    root.style.removeProperty('--ith-vv-h');
    root.style.removeProperty('--ith-vv-top');
  }

  if (vv) {
    vv.addEventListener('resize', syncViewport);
    vv.addEventListener('scroll', syncViewport);
  }

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input, textarea')) return;
    if (!cd.contains(t)) return;
    kbOn(t);
  });

  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (!t || !cd.contains(t)) return;
    // si le focus passe à un autre champ du panier, on reste en mode clavier
    setTimeout(function () {
      var a = document.activeElement;
      if (!a || !cd.contains(a) || !a.matches('input, textarea')) kbOff();
    }, 50);
  });
})();
